export default __webpack_public_path__ + "static/media/saveNarration.fce72e77.png";